<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { Modal } from "bootstrap";
// import store from "@/state/store";
// var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      // Start holidays setup
      HrHolidays: [],
      HrDepartments: [],
      holiday: {},
      allSelected: false,
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrHolidays: null,
      HrHolidaysSearchMode: false,
      searchModel: "",
      // state: state,
      // End holidays setup

      // Start holidays departments setup
      HrHolidayDepartments: [],
      departmentsPage: 1,
      departmentsLimit: 20,
      departmentsTotalPages: 0,
      searchHrHolidayDepartments: null,
      HrHolidayDepartmentsSearchMode: false,
      searchDepartmentsModel: "",
      // End holidays departments setup
    };
  },
  methods: {
    // Start holidays mehtods
    addHrHolidays() {
      this.holiday.departments = [];
      this.HrDepartments.forEach((department) => {
        if (department.checked) {
          this.holiday.departments.push({ hr_department_id: department.id });
        }
      });
      this.http.post("hr-holidays", this.holiday).then(() => {
        this.addModal.hide();

        this.get(this.page);
      });
    },
    editHrHolidays(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "hr_holidays.name",
            value: app.name,
          },
          {
            model: "start_date",
            type: "date",
            label: "hr_holidays.start_date",
            value: app.start_date,
          },
          {
            model: "end_date",
            type: "date",
            label: "hr_holidays.end_date",
            value: app.end_date,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("hr-holidays", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    search(page) {
      this.HrHolidaysSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("hr-holidays/search", {
          search: this.searchModel,
          limit: this.limit,
          page: page,
          col: "name",
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrHolidays = res.data;
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrHolidaysSearchMode = false;
      this.get(this.page);
    },
    getHrHolidays() {
      this.http.get("hr-holidays").then((res) => {
        this.HrHolidays = res.data;
      });
    },
    deleteHrHolidays(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("hr-holidays", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },
    get(page) {
      console.log(page);
      this.http
        .post("hr-holidays/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          if (res.status) {
            this.page = page;
            this.tot_pages = Math.ceil(res.tot / this.limit);
            this.HrHolidays = res.data;
            this.getHrHolidayDepartments();
          }
        });
    },
    // End holidays mehtods

    // Start holidays departments mehtods
    addHrHolidayDepartments() {
      if (this.HrDepartments.length <= 0) {
        this.http.get("hr-departments").then((resp) => {
          this.HrDepartments = resp.data;
          var data = {
            title: "popups.add",
            inputs: [
              {
                model: "hr_hoilday_id",
                type: "select",
                options: (() => {
                  return this.HrHolidays.map((data) => {
                    return { value: data.id, label: data.name };
                  });
                })(),
                label: "Holidays",
              },
              {
                model: "hr_department_id",
                type: "select",
                options: (() => {
                  return this.HrDepartments.map((data) => {
                    return { value: data.id, label: data.name };
                  });
                })(),
                label: "Departments",
              },
            ],
            buttons: [
              {
                text: "popups.add",
                closer: true,
                color: "primary",
                handler: (obj) => {
                  this.http.post("hr-holiday-departments", obj).then(() => {
                    this.getDepartmentsPagination(this.departmentsPage, false);
                  });
                },
              },
              {
                text: "popups.cancel",
                closer: true,
                color: "danger",
                handler: () => {
                  console.log("Like Clicked");
                },
              },
            ],
          };
          this.popup.modal(data);
        });
        return;
      }
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "hr_hoilday_id",
            type: "select",
            options: (() => {
              return this.HrHolidays.map((data) => {
                return { value: data.id, label: data.name };
              });
            })(),
            label: "Holidays",
          },
          {
            model: "hr_department_id",
            type: "select",
            options: (() => {
              return this.HrDepartments.map((data) => {
                return { value: data.id, label: data.name };
              });
            })(),
            label: "Departments",
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("hr-holiday-departments", obj).then(() => {
                this.getDepartmentsPagination(this.departmentsPage, false);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrHolidayDepartments(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "hr_hoilday_id",
            type: "select",
            value: app.hr_hoilday_id,
            options: (() => {
              return this.HrHolidays.map((data) => {
                return {
                  value: data.id,
                  label: data.name,
                };
              });
            })(),
            label: "hr_holiday_departments.hr_hoilday_id",
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("hr-holiday-departments", app.id, obj).then(() => {
                this.getDepartmentsPagination(this.departmentsPage, false);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    searchDepartments(departmentsPage) {
      this.HrHolidayDepartmentsSearchMode = true;
      this.departmentsTotalPages = 0;
      this.http
        .post("hr-holiday-departments/search", {
          search: this.searchDepartmentsModel,
          limit: this.departmentsLimit,
          page: departmentsPage,
          col: "name",
        })
        .then((res) => {
          this.page = departmentsPage;
          this.departmentsTotalPages = Math.ceil(
            res.tot / this.departmentsLimit
          );
          this.HrHolidayDepartments = res.data;
        });
    },
    cancelDepartmentsSearchMode() {
      this.searchDepartmentsModel = "";
      this.HrHolidayDepartmentsSearchMode = false;
      this.getDepartmentsPagination(this.page, false);
    },
    getHrHolidayDepartments() {
      this.http.get("hr-departments").then((res) => {
        this.HrDepartments = res.data;
        this.HrDepartments.forEach((department) => {
          department.checked = false;
        });
      });
    },
    deleteHrHolidayDepartments(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("hr-holiday-departments", app.id).then(() => {
            this.getDepartmentsPagination(this.page, false);
          });
        }
      });
    },
    getDepartmentsPagination(page, tabClick) {
      if (tabClick && this.HrHolidayDepartments.length > 0) return;
      this.http
        .post("hr-holiday-departments/pagination", {
          limit: this.departmentsLimit,
          page: page,
        })
        .then((res) => {
          if (res.status) {
            this.departmentsPage = page;
            this.departmentsTotalPages = Math.ceil(
              res.tot / this.departmentsLimit
            );
            this.HrHolidayDepartments = res.data;
          }
        });
    },
    // End holidays departments mehtods
  },
  created() {
    this.get(1);
  },
  mounted() {
    this.addModal = new Modal("#addModal");
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.hr.subItems.holidays')"
    />
    <!-- Start holidays tab -->

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div class="search-box chat-search-box w-50">
                  <div class="position-relative">
                    <input
                      @input="search(page)"
                      type="search"
                      class="form-control fa-lg text-light"
                      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                      :placeholder="$t('popups.search')"
                      v-model="searchModel"
                      style="background-color: #2a3042 !important"
                    />
                    <i class="bx bx-search-alt search-icon text-light"></i>
                  </div>
                </div>
              </div>
              <div
                class="col-6"
                style="display: flex; justify-content: flex-end"
              >
                <!-- <button
                      class="btn-close text-light"
                      v-if="HrHolidaysSearchMode"
                      @click="cancelappsearchMode()"
                    ></button> -->
                <button
                  type="button"
                  @click="addModal.show()"
                  class="btn btn-light float-end mb-4"
                >
                  <span
                    class="bx bxs-plus-circle float-end fa-2x"
                    style="color: #2a3042 !important"
                  ></span>
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table
                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                class="table table-centered table-nowrap table-striped table-hover"
              >
                <thead>
                  <tr
                    class="text-light"
                    style="background-color: #2a3042 !important"
                  >
                    <th>#</th>
                    <th>{{ $t("hr_holidays.name") }}</th>
                    <th>{{ $t("hr_holidays.start_date") }}</th>
                    <th>{{ $t("hr_holidays.end_date") }}</th>

                    <th>{{ $t("hr_holidays.operations") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(app, index) in HrHolidays" :key="app" class="">
                    <td>{{ index + 1 }}</td>
                    <td>{{ app?.name }}</td>
                    <td>{{ app?.start_date }}</td>
                    <td>{{ app?.end_date }}</td>

                    <td class="d-flex">
                      <a
                        class="btn btn-primary mx-1"
                        @click="editHrHolidays(app)"
                        href="javascript: void(0);"
                        role="button"
                        >{{ $t("popups.edit") }}</a
                      >
                      <a
                        class="btn btn-danger"
                        href="javascript: void(0);"
                        role="button"
                        @click="deleteHrHolidays(app)"
                        >{{ $t("popups.delete") }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- end  table -->
            <div>
              <!--   Apps  Pagination     -->
              <ul
                class="pagination pagination-rounded justify-content-center mb-2"
              >
                <li class="page-item" :class="{ disabled: page == 1 }">
                  <a
                    class="page-link"
                    href="javascript: void(0);"
                    @click="searchModel ? search(page - 1) : get(page - 1)"
                    aria-label="Previous"
                  >
                    <i class="mdi mdi-chevron-left"></i>
                  </a>
                </li>
                <li
                  class="page-item"
                  :class="{ active: p == page }"
                  v-for="p in tot_pages"
                  :key="p"
                >
                  <a
                    class="page-link"
                    href="javascript: void(0);"
                    @click="searchModel ? search(p) : get(p)"
                    >{{ p }}</a
                  >
                </li>

                <li class="page-item" :class="{ disabled: page == tot_pages }">
                  <a
                    class="page-link"
                    href="javascript: void(0);"
                    @click="searchModel ? search(page + 1) : get(page + 1)"
                    aria-label="Next"
                  >
                    <i class="mdi mdi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="addHrHolidays()">
            <div class="modal-header">
              <h5 class="modal-title w-100" id="exampleModalLabel">
                {{ $t("popups.add") }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0"
              ></button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label for="name">{{ $t("hr_holidays.name") }}</label>
                <input
                  v-model="holiday.name"
                  id="holiday_name"
                  required
                  class="form-control"
                  type="text"
                  :placeholder="$t('hr_holidays.name')"
                />
              </div>
              <div class="form-group">
                <label for="name">{{ $t("hr_holidays.start_date") }}</label>
                <input
                  type="date"
                  id="start_date"
                  v-model="holiday.start_date"
                  required
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label for="name">{{ $t("hr_holidays.end_date") }}</label>
                <input
                  type="date"
                  id="end_date"
                  v-model="holiday.end_date"
                  required
                  class="form-control"
                />
              </div>
            </div>

            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.add") }}
              </button>
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  font-size: 15px;
}
</style>
